export default __webpack_public_path__ + "static/media/BR - CTF3.31f538c4.png";